module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/CPU1-22674517c5222c19e7d92c4ba85b7f90.svg";